import * as S from './styled';

export interface StepProps {
  title: string;
  description?: string;
}

export interface Props {
  steps: StepProps[];
  inverted?: boolean;
}

export const VerticalStepper = ({ steps, inverted = false }: Props) => (
  <S.Stepper $inverted={inverted}>
    {steps.map(({ title, description }: StepProps, index: number) => (
      <S.StepperItem $inverted={inverted} key={index}>
        <S.StepperContent>
          <S.StepperTitle $inverted={inverted} dangerouslySetInnerHTML={{ __html: title }} />
          {description && <S.StepperDesc>{description}</S.StepperDesc>}
        </S.StepperContent>
      </S.StepperItem>
    ))}
  </S.Stepper>
);
